export const UPDATE_COMPANIESLIST = "UPDATE_COMPANIESLIST";
export const UPDATE_SELECTEDCOMPANIES = "UPDATE_SELECTEDCOMPANIES";
export const SET_FIND_BUSINESS_RESULTS = "SET_FIND_BUSINESS_RESULTS";
export const CLEAR_FIND_BUSINESS_RESULTS = "CLEAR_FIND_BUSINESS_RESULTS";
export const SET_CREDIT_MAP_RESULTS = "SET_CREDIT_MAP_RESULTS";
export const CLEAR_CREDIT_MAP_RESULTS = "CLEAR_CREDIT_MAP_RESULTS";
